import { useState } from 'react';
import type { ReactNode } from 'react';

import { useClarity } from '@woovi/clarity';

import type { OrderProps } from './Order.tsx';
import OrderApp from './OrderApp.tsx';
import { config } from '../config.tsx';
import { Providers } from '../Providers.tsx';
import { getEnv } from '../relay/Environment.tsx';

const OrderRoot = (props: OrderProps): ReactNode => {
  useClarity({
    clarityId: config.CLARITY_ID,
  });

  const { appID } = props;
  const [environment] = useState(() => getEnv(appID));

  return (
    <Providers environment={environment}>
      <OrderApp {...props} />
    </Providers>
  );
};

export default OrderRoot;
